export default __webpack_public_path__ + "static/media/pulp_fiction.4fcdde8f.webp";